import React from 'react';
import 'leaflet/dist/leaflet.css';
import { CircleMarker } from './CircleMarker';
import { RectangleMarker } from './RectangleMarker';
import { PentagonMarker } from './PentagonMarker';
import { DiamondMarker } from './DiamondMarker';
import { OctagonMarker } from './OctagonMarker';
import { Star5Marker } from './Star5Marker';
import { Star6Marker } from './Start6Marker';
import { TriangleMarker } from './TriangleMarker';
import { Star4Marker } from './Star4Marker';
export interface MarkersWrapperProps {
    key: string;
    shape: ShapeType;
    color: string;
    position: any;
    radius: number;
    fteDVMs: number;
    name: string;
    opacity: number;
    isAnimated: boolean;
    showTooltip: boolean;
    onClick?: (event: any) => void;
}

export enum ShapeType {
    Circle,
    Rectangle,
    Diamond,
    Pentagon,
    Octagon,
    Star4,
    Star5,
    Star6,
    Triangle,
}

const MarkersWrapper = (props: MarkersWrapperProps) => {
    let shapeElement = null;

    switch (props.shape) {
        case ShapeType.Circle:
            shapeElement = (
                <CircleMarker
                    onClick={props.onClick}
                    opacity={props.opacity}
                    key={props.key}
                    color={props.color}
                    position={props.position}
                    radius={props.radius}
                    fteDVMs={props.fteDVMs}
                    isAnimated={props.isAnimated}
                    showTooltip={props.showTooltip}
                    name={props.name}></CircleMarker>
            );
            break;

        case ShapeType.Rectangle:
            shapeElement = (
                <RectangleMarker
                    onClick={props.onClick}
                    key={props.key}
                    isAnimated={props.isAnimated}
                    color={props.color}
                    opacity={props.opacity}
                    position={props.position}
                    radius={props.radius}
                    showTooltip={props.showTooltip}
                    fteDVMs={props.fteDVMs}
                    name={props.name}></RectangleMarker>
            );
            break;

        case ShapeType.Diamond:
            shapeElement = (
                <DiamondMarker
                    onClick={props.onClick}
                    key={props.key}
                    color={props.color}
                    isAnimated={props.isAnimated}
                    opacity={props.opacity}
                    position={props.position}
                    showTooltip={props.showTooltip}
                    radius={props.radius}
                    fteDVMs={props.fteDVMs}
                    name={props.name}></DiamondMarker>
            );
            break;

        case ShapeType.Pentagon:
            shapeElement = (
                <PentagonMarker
                    onClick={props.onClick}
                    key={props.key}
                    color={props.color}
                    opacity={props.opacity}
                    isAnimated={props.isAnimated}
                    showTooltip={props.showTooltip}
                    position={props.position}
                    radius={props.radius}
                    fteDVMs={props.fteDVMs}
                    name={props.name}></PentagonMarker>
            );
            break;

        case ShapeType.Octagon:
            shapeElement = (
                <OctagonMarker
                    onClick={props.onClick}
                    key={props.key}
                    isAnimated={props.isAnimated}
                    color={props.color}
                    opacity={props.opacity}
                    position={props.position}
                    showTooltip={props.showTooltip}
                    radius={props.radius}
                    fteDVMs={props.fteDVMs}
                    name={props.name}></OctagonMarker>
            );
            break;

        case ShapeType.Star4:
            shapeElement = (
                <Star4Marker
                    onClick={props.onClick}
                    key={props.key}
                    isAnimated={props.isAnimated}
                    color={props.color}
                    position={props.position}
                    opacity={props.opacity}
                    radius={props.radius}
                    showTooltip={props.showTooltip}
                    fteDVMs={props.fteDVMs}
                    name={props.name}></Star4Marker>
            );
            break;

        case ShapeType.Star5:
            shapeElement = (
                <Star5Marker
                    onClick={props.onClick}
                    key={props.key}
                    isAnimated={props.isAnimated}
                    color={props.color}
                    position={props.position}
                    opacity={props.opacity}
                    radius={props.radius}
                    showTooltip={props.showTooltip}
                    fteDVMs={props.fteDVMs}
                    name={props.name}></Star5Marker>
            );
            break;

        case ShapeType.Star6:
            shapeElement = (
                <Star6Marker
                    onClick={props.onClick}
                    key={props.key}
                    isAnimated={props.isAnimated}
                    color={props.color}
                    position={props.position}
                    radius={props.radius}
                    showTooltip={props.showTooltip}
                    opacity={props.opacity}
                    fteDVMs={props.fteDVMs}
                    name={props.name}></Star6Marker>
            );
            break;

        case ShapeType.Triangle:
            shapeElement = (
                <TriangleMarker
                    onClick={props.onClick}
                    key={props.key}
                    color={props.color}
                    isAnimated={props.isAnimated}
                    position={props.position}
                    opacity={props.opacity}
                    showTooltip={props.showTooltip}
                    radius={props.radius}
                    fteDVMs={props.fteDVMs}
                    name={props.name}></TriangleMarker>
            );
            break;

        default:
            shapeElement = (
                <CircleMarker
                    onClick={props.onClick}
                    key={props.key}
                    opacity={props.opacity}
                    isAnimated={props.isAnimated}
                    color={props.color}
                    showTooltip={props.showTooltip}
                    position={props.position}
                    radius={props.radius}
                    fteDVMs={props.fteDVMs}
                    name={props.name}></CircleMarker>
            );
    }

    return shapeElement;
};

export default MarkersWrapper;
